module.exports = __webpack_public_path__ + "img/programs_pricing.e67157c5.png";